import React, { useState, useEffect } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import { InputAdornment, TextField } from "@mui/material";

export const MdlVerificacionCondicionesCredito = ({ folio, setLoader, loader }) => {
  const [openComentarios, setOpenComentarios] = useState(false);
  const [comentarios, setComentarios] = useState("");
  const [accion, setAccion] = useState("");
  const [estatus, setEstatus] = useState({});
  const onChange = (prop, value, sbool, smensaje) => {
    setComentarios(value);
  };
  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: 8,
      responsable: "C",
    };
    request
      .post(`ACAnalisisDecicion`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "VERIFICACION DE CUMPLIMINETO DE NUEVAS CONDICIONES",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);
  const onEnviarComentario = () => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "VERIFICACION DE CUMPLIMINETO DE NUEVAS CONDICIONES",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: 8,
      consecutivo: -1,
      comentarios,
      estatus: accion,
    };
    request
      .post("ACTimeLineComentarios", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
        setComentarios("");
        setOpenComentarios(false);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "VERIFICACION DE CUMPLIMINETO DE NUEVAS CONDICIONES",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const onAceptar = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: 8,
      consecutivo: -1,
      comentarios: "VERIFICACION DE CUMPLIMINETO DE NUEVAS CONDICIONES APROVADA",
      estatus: "A",
    };
    request
      .post("ACTimeLineComentarios", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
        setComentarios("");
        setOpenComentarios(false);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "VERIFICACION DE CUMPLIMINETO DE NUEVAS CONDICIONES",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };
  return (
    <div className="analisis-credito-modal-pedido">
      <div className="analisis-credito-modal-pedido-content">
        <div className="analisis-credito-modal-pedido-content-title">
          <div className="analisis-credito-modal-pedido-content-title-text">
            VERIFICACION DE CUMPLIMIENTO DE NUEVAS CONDICIONES 
          </div>
          <div className="analisis-credito-modal-pedido-content-title-estimate">
            TIEMPO DE RESPUESTA ESTIMADO: {estatus.tiempoestimado}
          </div>
        </div>
        <div className="analisis-credito-modal-pedido-content-buttons">
          {estatus.habilitar === undefined ||
          estatus.habilitar === null ||
          estatus.habilitar === false ? (
            <></>
          ) : (
            <>
              <div
                className="analisis-credito-modal-pedido-content-acept-button"
                onClick={() => {
                  onAceptar();
                }}
              >
                <CheckCircleIcon />
                <div>ACEPTAR</div>
              </div>
              <div
                className="analisis-credito-modal-pedido-content-cancel-button"
                onClick={() => {
                  setOpenComentarios(!openComentarios);
                  setAccion("R");
                }}
              >
                <CancelIcon />
                <div>RECHAZAR</div>
              </div>
            </>
          )}
        </div>
        {estatus.habilitar === undefined ||
          estatus.habilitar === null ||
          (estatus.habilitar === false && (
            <div
              className={`analisis-credito-modal-pedido-content-comentarios analisis-credito-modal-pedido-content-comentarios-${estatus.icono}`}
            >
              <label>Comentarios</label>
              <div className="analisis-credito-modal-pedido-content-comentarios-svg">
                <OnGetIcon icon={estatus.icono} />
              </div>
              <div className="analisis-credito-modal-pedido-content-comentarios-div">
                {estatus.comentarios}
              </div>
            </div>
          ))}
      </div>
      <div className="analisis-credito-modal-pedido-footer">
        {openComentarios && (
          <TextField
            fullWidth
            size="small"
            label="COMENTARIOS"
            className="cel-1"
            multiline
            rows={4}
            type="text"
            // error={condiciones.bcondiciones}
            onChange={({ target }) => {
              ValSpecialCharacters(
                "condiciones",
                target.value,
                onChange,
                true,
                500
              );
            }}
            value={comentarios}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <CancelScheduleSendIcon
                    onClick={() => onEnviarComentario()}
                  />
                </InputAdornment>
              ),
            }}
          />
        )}
      </div>
    </div>
  );
};
